import { mainNavigationSelectors as selector } from "../Selectors/index";

export const mainNavigationReducer = (state = [], { type, payload }) => {
  switch (type) {
    case selector.GET_ROLE_SUCCESS:
      // console.log("Setting Main Navigation in Redux state:", payload);
      return payload;

    default:
      return state;
  }
};